import { render, staticRenderFns } from "./WikiHomeSkeleton.vue?vue&type=template&id=0b345815&scoped=true"
import script from "./WikiHomeSkeleton.vue?vue&type=script&lang=js"
export * from "./WikiHomeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./WikiHomeSkeleton.vue?vue&type=style&index=0&id=0b345815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b345815",
  null
  
)

export default component.exports